import { NAV_SECTIONS } from '../config/navigation';

/** URL yolundan sekme başlığı (mobil üst çubuk). */
export function titleForPath(pathname) {
  const slug = (pathname || '').replace(/^\//, '').split('/')[0] || 'dashboard';
  for (const section of NAV_SECTIONS) {
    const item = section.items.find((i) => i.path === slug);
    if (item) return item.label;
  }
  return 'Site Analiz';
}
